import React, { Component } from 'react'
import actions from 'redux/actions'
import PropTypes from 'prop-types'
import { connect } from 'redaction'
import { getUserFullNameFromState, constants, snowplow } from 'common/helpers'
import { FormattedMessage } from 'sb-react-intl'

import Modal from 'components/modal/Modal/Modal'
import SkipAMonthButton from 'compositions/buttons/SkipAMonthButton/SkipAMonthButton'
import ChangeFrequencyButton from 'compositions/buttons/ChangeFrequencyButton/ChangeFrequencyButton'
import { openChangeFrequencyModal } from 'compositions/modals/changeFrequency'

import ContinueCancellation from '../ContinueCancellation/ContinueCancellation'

import messages from './messages'
import s from './BeforeYouGoModal.scss'


class BeforeYouGoModal extends Component {

  static propTypes = {
    myFullName: PropTypes.string, // @connect
    isSkippable: PropTypes.bool,  // @connect
    isFrequencyChangeable: PropTypes.bool,  // @connect
    isPauseSubscriptionEnabled: PropTypes.bool,  // @connect
    name: PropTypes.string.isRequired,
    onClose: PropTypes.func,
    placement: PropTypes.string,
  }

  static defaultProps = {
    name: constants.modals.cancelSubscription.BeforeYouGo,
  }

  handleChangeFrequency = () => {
    this.trackCloseModal('change frequency')
    this.close()

    openChangeFrequencyModal({
      popup: 'before you go modal',
      withFeedback: true,
    })
  }

  close = () => {
    const { name, onClose } = this.props

    actions.models.modals.close(name)

    if (typeof onClose === 'function') {
      onClose()
    }
  }

  trackCloseModal = (action) => {
    snowplow.track(constants.snowplowEvents.cancelSubscriptionStepComplete, {
      stepName: 'before you go',
      action,
    }, false)
  }

  handleSkipAMonth = () => {
    this.trackCloseModal('skip month')
    this.close()
    actions.models.modals.open(constants.modals.SkipAMonth)
  }

  continueCancellation = () => {
    const { isPauseSubscriptionEnabled } = this.props

    this.close()

    if (isPauseSubscriptionEnabled) {
      actions.models.modals.open(constants.modals.cancelSubscription.PauseSubscription)
    }
    else {
      actions.models.modals.open(constants.modals.cancelSubscription.OneLastQuestion)
    }
  }

  handleCloseModal = () => {
    this.trackCloseModal('close')
  }

  render() {
    const { name, myFullName, isFrequencyChangeable, isSkippable } = this.props

    return (
      <Modal
        name={name}
        title={messages.title}
        className={s.beforeYouGoModal}
        onClose={this.handleCloseModal}
      >
        <div className={s.userName}>{myFullName}</div>
        <FormattedMessage tag="div" {...messages.text} />
        <div className={s.options}>
          {
            isFrequencyChangeable && (
              <div className={s.section}>
                <FormattedMessage className={s.sectionTitle} tag="div" {...messages.changeFrequencyText} />
                <div className={s.buttonContainer}>
                  <ChangeFrequencyButton className={s.button} fullWidth onClick={this.handleChangeFrequency} />
                </div>
              </div>
            )
          }
          {
            isSkippable && (
              <div className={s.section}>
                <FormattedMessage className={s.sectionTitle} tag="div" {...messages.skipAMonthText} />
                <div className={s.buttonContainer}>
                  <SkipAMonthButton
                    className={s.button}
                    fullWidth
                    placement="cancel subscription popup"
                    onClick={this.handleSkipAMonth}
                  />
                </div>
              </div>
            )
          }
        </div>
        <ContinueCancellation onClick={this.continueCancellation} />
      </Modal>
    )
  }
}


export default connect({
  myFullName: (state) => getUserFullNameFromState(state),
  isSkippable: 'models.subscription.isSkippable',
  isFrequencyChangeable: 'models.subscription.isFrequencyChangeable',
  isPauseSubscriptionEnabled: (state) => {
    const { models: { subscription: { isPaused } } } = state

    return !isPaused
  },
})(BeforeYouGoModal)
